import React, { useEffect, useState } from "react";

const ReadMore = ({ name, text = "", maxLength = 100 }) => {
  const [showOption, setShowOption] = useState(false);
  const [readMore, setReadMore] = useState(false);
  const [readMoreText, setReadMoreText] = useState("");

  useEffect(() => {
    setReadMoreText(text);
  }, []);

  useEffect(() => {
    if (text) {
      if (text.length > maxLength) {
        setReadMoreText(text.substr(0, maxLength) + "...");
        setShowOption(true);
      }
    }
  }, [text]);

  useEffect(() => {
    if (readMore) {
      setReadMoreText(text);
    } else {
      let trimmedText = text.substr(0, maxLength);
      trimmedText = showOption ? trimmedText + "... " : trimmedText;
      setReadMoreText(trimmedText);
    }
  }, [readMore, showOption]);

  const showMore = () => {
    setReadMore(!readMore);
  };

  return (
    <>
      {readMoreText}

      {showOption && (
        <>
          <a onClick={showMore} className="read-more">
            {readMore ? " " + name + " Less" : name + " More"}
          </a>
        </>
      )}
    </>
  );
};

export default ReadMore;
